// see styles/themes/base/_duration.scss
export enum Speed {
  Fast = 200,
  Normal = 400,
  Slow = 600,
}
